import wildCardSearch from 'utils/wildCardSearch'
import sortBy from 'utils/sortBy'
import paginate from 'utils/paginate'

export default function salesFakeApi (server, apiPrefix) {

    server.post(`${apiPrefix}/sales/dashboard`, (schema) => {
        return schema.db.salesDashboardData[0]
    })
    
    server.post(`${apiPrefix}/sales/products`, (schema, {requestBody}) => {
        const body = JSON.parse(requestBody)
        const { pageIndex, pageSize, sort, query } = body
        const { order, key } = sort
        const products = schema.db.productsData
        const sanitizeProducts = products.filter(elm => typeof elm !== 'function')
        let data = sanitizeProducts
        let total = products.length

        if((key === 'category' || key === 'name') && order) {
            data.sort(sortBy(key, order === 'desc' , (a) =>  a.toUpperCase()))
        } else {
            data.sort(sortBy(key, order === 'desc', parseInt))
        }

        if(query) {
            data = wildCardSearch(data, query)
            total = data.length
        }

        data = paginate(data, pageSize, pageIndex)

        const responseData = {
            data: data,
            total: total
        } 
        return responseData
    })

    server.del(`${apiPrefix}/sales/products/delete`, (schema, {requestBody}) => {
        const { id } = JSON.parse(requestBody)
        schema.db.productsData.remove({id})
        return true
    })

    server.get(`${apiPrefix}/sales/product`, (schema, {queryParams}) => {
        const id = queryParams.id
        const product = schema.db.productsData.find(id)
        return product
    })

    server.put(`${apiPrefix}/sales/products/update`, (schema, {requestBody}) => {
        const data = JSON.parse(requestBody)
        const { id } = data
        schema.db.productsData.update({id}, data)
        return true
    })

    server.post(`${apiPrefix}/sales/products/create`, (schema, {requestBody}) => {
        const data = JSON.parse(requestBody)
        schema.db.productsData.insert(data)
        return true
    })

    server.get(`${apiPrefix}/sales/orders`, (schema, {queryParams}) => {
        const { pageIndex, pageSize, sort, query } = queryParams
        const { order, key } = JSON.parse(sort)
        const orders = schema.db.ordersData
        const sanitizeProducts = orders.filter(elm => typeof elm !== 'function')
        let data = sanitizeProducts
        let total = orders.length

        if(key) {
            if((key === 'date' || key === 'status' || key === 'paymentMehod') && order) {
                data.sort(sortBy(key, order === 'desc', parseInt))
            } else {
                data.sort(sortBy(key, order === 'desc' , (a) =>  a.toUpperCase()))
            }
        }

        if(query) {
            data = wildCardSearch(data, query)
            total = data.length
        }

        data = paginate(data, pageSize, pageIndex)
        
        const responseData = {
            data: data,
            total: total
        }
        return responseData
    })

    server.del(`${apiPrefix}/sales/orders/delete`, (schema, {requestBody}) => {
        const { id } = JSON.parse(requestBody)
        id.forEach(elm => {
            schema.db.ordersData.remove({id: elm})
        })
        return true
    })

    server.get(`${apiPrefix}/sales/orders-details`, (schema, {queryParams}) => {
        const { id } = queryParams
        const orderDetail = schema.db.orderDetailsData
        orderDetail[0].id = id
        return orderDetail[0]
    })

    server.post(`${apiPrefix}/v1/client-invoices`, (schema) => {
        const mockInvoices = [
            {
                paypal_invoice_id: "INV2-A45B-XYZ9",
                paypal_invoice_number: "0001",
                invoice_date: "2023-10-12",
                invoicer_view_url: "https://paypal.com/invoice/INV2-A45B-XYZ9",
                payment_status: "Paid",
                amount: "$1,500.00",
                user__first_name: "Demo",
                user__last_name: "Client",
                start_date: "2023-10-01",
                end_date: "2023-10-12"
            }
        ];
        return { data: mockInvoices, total: mockInvoices.length }
    })

    server.post(`${apiPrefix}/v1/invoices`, (schema) => {
        const mockInvoices = [
            {
                paypal_invoice_id: "INV2-A45B-XYZ9",
                paypal_invoice_number: "0001",
                invoice_date: "2023-10-12",
                invoicer_view_url: "https://paypal.com/invoice/INV2-A45B-XYZ9",
                payment_status: "Paid",
                amount: "$1,500.00",
                user__first_name: "Demo",
                user__last_name: "Client",
                start_date: "2023-10-01",
                end_date: "2023-10-12"
            },
            {
                paypal_invoice_id: "INV2-C78D-DEF8",
                paypal_invoice_number: "0002",
                invoice_date: "2023-11-05",
                invoicer_view_url: "https://paypal.com/invoice/INV2-C78D-DEF8",
                payment_status: "Unpaid",
                amount: "$750.00",
                user__first_name: "Jane",
                user__last_name: "Doe",
                start_date: "2023-10-15",
                end_date: "2023-11-05"
            }
        ];
        return { data: mockInvoices, total: mockInvoices.length }
    })

    server.get(`${apiPrefix}/v1/invoices`, () => {
        return { projects: [], clients: [] }
    })

    server.get(`${apiPrefix}/clients/`, () => {
        return { clients: [] }
    })

    server.post(`${apiPrefix}/clients/`, (schema) => {
        const mockClients = [
            {
                id: 1,
                first_name: "Demo",
                last_name: "Client",
                middle_name: "",
                suffix_name: "",
                email: "client@test.com",
                address: "123 Main St, NY",
                total_projects: 2,
                thumbnail: ""
            },
            {
                id: 2,
                first_name: "Jane",
                last_name: "Doe",
                middle_name: "A",
                suffix_name: "",
                email: "jane.doe@example.com",
                address: "456 Elm St, CA",
                total_projects: 1,
                thumbnail: ""
            }
        ];
        mockClients.forEach(client => {
            const count = (schema.db.projectList || []).filter(p => {
                const pFirst = p.client_id__first_name || 'Demo';
                const pLast = p.client_id__last_name || 'Client';
                return pFirst === client.first_name && pLast === client.last_name;
            }).length;
            client.total_projects = count;
        });

        return { data: mockClients, total: mockClients.length }
    })

    server.post(`${apiPrefix}/clients/:id`, (schema, request) => {
        const id = request.params.id; // e.g. "Demo-Client-1"
        const projects = schema.db.projectList || [];
        const mappedProjects = projects.map(p => ({
            ...p,
            project_name: p.project_name || p.name,
            project_status: p.project_status || 'in progress',
            proj_url: p.proj_url || (p.project_name || p.name || '').replace(/#/g, '').replace(/\s+/g, '-').toLowerCase(),
            total_photos: p.total_photos || 0,
            creation_date: p.creation_date || new Date().toISOString(),
            proj_deadline: p.proj_deadline || new Date(new Date().setDate(new Date().getDate() + 7)).toISOString(),
            client_id__first_name: p.client_id__first_name || 'Demo',
            client_id__last_name: p.client_id__last_name || 'Client',
            client_id__middle_name: p.client_id__middle_name || '',
            client_id__suffix_name: p.client_id__suffix_name || '',
            client_id__thumbnail: p.client_id__thumbnail || '',
            editors: p.editors || p.member || []
        }));
        // Just return all projects for demo purposes
        return { data: mappedProjects, total: mappedProjects.length };
    })
}